// @ts-nocheck


import queryString from 'query-string';





import {
  fetchRequest,
  downloadRequestWithToken,
  initialFetchListParams } from
'./index';

import { convertFromKopToRub, convertFromRubToKop } from '../pure/unitConversions';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';


export const convertDataFromServer = (
expertiseServiceGpm) => (
{
  ...expertiseServiceGpm,
  paymentAmount: convertFromKopToRub(expertiseServiceGpm.paymentAmount)
});

export const convertDataToServer = (
expertiseServiceGpm) => (
{
  ...expertiseServiceGpm,
  paymentAmount: convertFromRubToKop(expertiseServiceGpm.paymentAmount)
});

export const addExpertiseServiceGpm = async (
expertiseServiceGpm) =>
{
  const added = await fetchRequest.post(
    '/expertiseServiceGpm',
    convertDataToServer(expertiseServiceGpm)
  );
  if (added) return added;
  throw new Error('Не удалось создать экспертизу/тех. обслуживание ГПМ');
};

export const updateExpertiseServiceGpm = async (
expertiseServiceGpm) =>
{
  const updated = await fetchRequest.put(
    '/expertiseServiceGpm',
    convertDataToServer(expertiseServiceGpm)
  );
  if (updated) return convertDataFromServer(updated);
  throw new Error('Не удалось обновить экспертизу/тех. обслуживание ГПМ');
};

export const deleteExpertiseServiceGpm = async (
id) =>
{
  const deleted = await fetchRequest.delete(`/expertiseServiceGpm/${id}`);
  if (deleted) return convertDataFromServer(deleted);
  throw new Error('Не удалось удалить экспертизу/тех. обслуживание ГПМ');
};

export const fetchExpertiseServiceGpm = async (
id,
params = {}) =>
{
  const expertiseServiceGpm = await fetchRequest.get(
    `/expertiseServiceGpm/${id}`,
    params
  );
  if (expertiseServiceGpm) return convertDataFromServer(expertiseServiceGpm);
  throw new Error('Не удалось получить экспертизу/тех. обслуживание ГПМ');
};

export const fetchVehicleExpertiseServiceGpmList = async (
vehicleId,
params = initialFetchListParams) =>
{
  const expertiseServiceGpmes = await fetchRequest.get(
    `/expertiseServiceGpm/vehicle/${vehicleId}`,
    {
      ...initialFetchListParams,
      ...params
    }
  );
  if (expertiseServiceGpmes) {
    return {
      ...expertiseServiceGpmes,
      data: expertiseServiceGpmes.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось список экспертиз/тех. обслуживаний ГПМ');
};

export const fetchExpertiseServiceGpmList = async (
params = initialFetchListParams) =>
{
  const expertiseServiceGpm = await fetchRequest.get('/expertiseServiceGpm', {
    ...initialFetchListParams,
    ...params
  });
  if (expertiseServiceGpm) {
    return {
      ...expertiseServiceGpm,
      data: expertiseServiceGpm.data.map(convertDataFromServer)
    };
  }
  throw new Error('Не удалось получить список экспертиз/тех. обслуживаний ГПМ');
};

export const updateAct = async (
params,
data) =>
{
  const expertiseServiceGpm = await fetchRequest.put(
    `/expertiseServiceGpm/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (expertiseServiceGpm) {
    return {
      ...expertiseServiceGpm,
      data: expertiseServiceGpm.data.map(convertDataFromServer)
    };
  }
  throw new Error(
    'Не удалось закрепить акт за экспертиз/тех. обслуживаний ГПМ'
  );
};

export const printReport = async (
params,
fileName) =>
{
  const isPrinted = await downloadRequestWithToken(
    '/expertiseServiceGpm/print',
    params,
    fileName
  );
  if (isPrinted) return true;
  throw new Error('Не удалось загрузить отчет');
};

export const getTotalSum = async (params = {}) => {
  const sum = await fetchRequest.get(`/expertiseServiceGpm/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
params = {}) =>
{
  const groupedList = await fetchRequest.get(
    `/expertiseServiceGpm/groupedList`,
    params
  );
  if (groupedList)
  return {
    ...groupedList,
    data: groupedList.data.map(convertDataFromServerGroupedList)
  };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export default {
  groupedList,
  getTotalSum,
  printReport,
  updateAct,
  addExpertiseServiceGpm,
  updateExpertiseServiceGpm,
  deleteExpertiseServiceGpm,
  fetchExpertiseServiceGpm,
  fetchVehicleExpertiseServiceGpmList,
  fetchExpertiseServiceGpmList
};
